import ACTION from "../../config/contants/action";

const initialState = {
  lang: 'ja',
};

const langReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.CHANGE_LANGUAGE: {
      const newLang = action.payload.language;
      return {
        ...state,
        lang: newLang,
      };
    }
    default:
      return state;
  }
};

export default langReducer;
